// Core imports
import * as React from 'react';
import { disableScroll, enableScroll } from 'src/utils/documentInteraction';

// Components imports
import EmailInvoicesModal from '../EmailInvoicesModal';
import Modal from 'src/components/common/Modal';
import SlideMenu from 'src/components/common/SlideMenu';

// Models imports
import InvoiceModel from 'src/model/invoice.model';

// Style and misc imports
import './InvoiceToolbar.scss';

class InvoiceToolbar extends React.Component<
  IInvoiceToolbarProps,
  IInvoiceToolbarState
> {
  constructor(props: IInvoiceToolbarProps) {
    super(props);

    this.state = {
      modalIsOpen: false
    };
  }

  /* 
    getClearButton
   */
  private getClearButton = () => {
    const { selectedInvoices } = this.props;
    if (selectedInvoices.length !== 0) {
      return (
        <i
          className="rpds-close rp-invoices--toolbar--clear-icon"
          onClick={() => {
            this.props.onClearClicked();
          }}
        />
      );
    } else {
      return <React.Fragment />;
    }
  };

  /* 
    getClearSection : Returns a button to clear selection or a react fragment
   */
  private getClearSection = (t: any) => {
    const { selectedInvoices } = this.props;
    if (selectedInvoices.length !== 0) {
      return (
        <div
          className="rp-invoices--toolbar--count"
          onClick={() => {
            this.props.onClearClicked();
          }}
        >
          <span className="clear-selection">{t('common.clearSelection')}</span>
          <span className="count-selected">{`(${t('invoices.invoiceWithCount', {
            count: selectedInvoices.length
          })} ${t('common.selected')})`}</span>
        </div>
      );
    } else {
      return <React.Fragment />;
    }
  };

  /* 
    openEmailModal
   */
  private openEmailModal = () => {
    this.setState({ modalIsOpen: true });
    window.scrollTo(0, 0);
    disableScroll();
  };

  /* 
    closeEmailModal
   */
  private closeEmailModal = () => {
    this.setState({ modalIsOpen: false });
    enableScroll();
  };

  /* 
    getEmailModal
   */
  private getEmailModal = () => {
    const { t, selectedInvoices } = this.props;

    return (
      <React.Fragment>
        <div className="send-email-desktop">
          {this.state.modalIsOpen ? (
            <Modal showClose={true} handleCloseModal={this.closeEmailModal}>
              <EmailInvoicesModal
                selectedInvoices={selectedInvoices}
                removeInvoiceFromSelected={this.props.removeInvoiceFromSelected}
                closeModal={this.closeEmailModal}
              />
            </Modal>
          ) : (
            <React.Fragment />
          )}
        </div>
        <div className="send-email-mobile">
          <SlideMenu
            mounted={this.state.modalIsOpen}
            level={20 + 30}
            handleCloseMenu={this.closeEmailModal}
            goBackTitle={t('common.backToResults')}
          >
            <EmailInvoicesModal
              selectedInvoices={selectedInvoices}
              removeInvoiceFromSelected={this.props.removeInvoiceFromSelected}
              closeModal={this.closeEmailModal}
            />
          </SlideMenu>
        </div>
      </React.Fragment>
    );
  };

  private filterInvoicesToDownloadOrSend = (invoices: InvoiceModel[]) => {
    let filterInvoices: number = 0;
    filterInvoices = invoices.findIndex(invoice => {
      return invoice.orderNumber === null;
    });
    return filterInvoices;
  };

  public render() {
    const { t, selectedInvoices } = this.props;
    const status =
      selectedInvoices.length !== 0 &&
      this.filterInvoicesToDownloadOrSend(selectedInvoices) === -1
        ? 'active'
        : 'disabled';
    return (
      <React.Fragment>
        <div className={`rp-invoices--toolbar ${status}`}>
          <div className="rp-invoices--toolbar--clear">
            {this.getClearButton()}
            {this.getClearSection(t)}
          </div>
          <div className="rp-invoices--toolbar--buttons">
            <div
              className={`toolbar-email ${status}`}
              onClick={() => {
                if (selectedInvoices.length !== 0 && status === 'active') {
                  this.openEmailModal();
                }
              }}
            >
              <i className="rpds-mail" />
              <p>{t('common.sendEmail')}</p>
            </div>
            <div
              className={`toolbar-download ${status}`}
              onClick={() => {
                if (selectedInvoices.length !== 0 && status === 'active') {
                  this.props.onDownloadClicked();
                }
              }}
            >
              <i className="rpds-get-app" />
              <p>{t('common.download')}</p>
            </div>
          </div>
        </div>
        {this.getEmailModal()}
      </React.Fragment>
    );
  }
}

export default InvoiceToolbar;

interface IInvoiceToolbarProps {
  onDownloadClicked(): void;
  onClearClicked(): void;
  removeInvoiceFromSelected(invoice: InvoiceModel): void;
  t: any;
  selectedInvoices: InvoiceModel[];
}

interface IInvoiceToolbarState {
  modalIsOpen: boolean;
}
